import React, { useEffect, useRef, useContext } from "react";

import { DataContext } from "../context/DataContext";

export const Segmentation = (props) => {
  const { data, setData, animation } = useContext(DataContext);
  const canvasRef = useRef();

  const drawSegmentation = (index = null, segment = null) => {
    let segment_ids = index ? data.segments[index].segment_ids : [];
    const original = document.getElementById("original");
    const canvas = canvasRef.current;
    canvas.width = original.width;
    canvas.height = original.height;
    const context = canvas.getContext("2d");

    let img = new Image();
    img.onload = function () {
      const original = document.getElementById("original");
      let tmp = document.createElement("canvas");
      tmp.width = original.width;
      tmp.height = original.height;

      let ctx = tmp.getContext("2d");
      ctx.drawImage(this, 0, 0, original.width, original.height);
      let image = ctx.getImageData(0, 0, original.width, original.height);
      let length = image.data.length;
      for (let i = 0; i < length; i += 4) {
        let R = image.data[i];
        let G = image.data[i + 1];
        let B = image.data[i + 2];
        let id = R + G * 256 + B * 256 ** 2;
        let color =
          !(id in data.segment_colors) ||
          (id !== segment) & (segment !== null) ||
          !segment_ids.includes(id) & (index !== null)
            ? [0, 0, 0, 0]
            : index !== null
            ? data.colors_rgba[Math.floor(index / 2)]
            : data.segment_colors[id];
        image.data[i] = color[0];
        image.data[i + 1] = color[1];
        image.data[i + 2] = color[2];
        image.data[i + 3] = color[3] * 256;
      }
      context.putImageData(image, 0, 0);
    };
    img.src = `https://lambda004.uniandes.edu.co/panoptic-narrative-grounding/annotations/panoptic_segmentation/${props.data.image_id.padStart(
      12,
      "0"
    )}.png`;
    img.setAttribute("crossOrigin", "");
  };

  const getId = (position) =>
    new Promise((resolve) => {
      let id = null;
      const original = document.getElementById("original");
      const canvas = canvasRef.current;
      canvas.width = original.width;
      canvas.height = original.height;

      let img = new Image();
      img.onload = function () {
        const original = document.getElementById("original");
        let tmp = document.createElement("canvas");
        tmp.width = original.width;
        tmp.height = original.height;

        let ctx = tmp.getContext("2d");
        ctx.drawImage(this, 0, 0, original.width, original.height);
        let image = ctx.getImageData(0, 0, original.width, original.height);
        if (position) {
          id =
            image.data[position * 4] +
            image.data[position * 4 + 1] * 256 +
            image.data[position * 4 + 2] * 256 ** 2;
        }
        resolve(id);
      };
      img.src = `https://lambda004.uniandes.edu.co/panoptic-narrative-grounding/annotations/panoptic_segmentation/${props.data.image_id.padStart(
        12,
        "0"
      )}.png`;
      img.setAttribute("crossOrigin", "");
    });

  const handleImageLoaded = () => {
    drawSegmentation(data.index, data.segment);
  };

  useEffect(() => {
    drawSegmentation(data.index, data.segment);
  });

  const handleClick = (e) => {
    if (data.playing) {
      handleStop();
    }
    const rect = e.target.getBoundingClientRect();
    const x = Math.round(e.clientX - rect.left);
    const y = Math.round(e.clientY - rect.top);
    getId(Math.round((y - 1) * Math.round(rect.width) + Math.round(x))).then(
      (id) => {
        setData({
          ...data,
          index: null,
          segment: id,
        });
      }
    );
  };

  const handleStop = () => {
    clearInterval(animation);
    setData((prevData) => ({
      ...prevData,
      playing: false,
    }));
  };

  return (
    <>
      <img
        id="original"
        src={`https://lambda004.uniandes.edu.co/panoptic-narrative-grounding/data/images/${data.image_id.padStart(
          12,
          "0"
        )}.jpg`}
        onLoad={handleImageLoaded}
        alt="Sample of the dataset"
      />
      <canvas id="overlay" ref={canvasRef} onClick={handleClick}></canvas>
    </>
  );
};
